import React, { FunctionComponent } from "react"

interface CharadesIconProps {}

const CharadesIcon: FunctionComponent<CharadesIconProps> = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="10.8" y="1.19995" width="2.4" height="21.6" rx="1.2" fill="#475766"/>
    <rect x="6.5" y="6.5" width="11" height="11" rx="4.5" fill="#05AAFF" stroke="#F0F4F7"/>
    <circle cx="5.5" cy="5.5" r="2.5" fill="#05AAFF"/>
    <circle cx="5.5" cy="18.5" r="2.5" fill="#05AAFF"/>
    <circle cx="2.5" cy="12.5" r="2.5" fill="#05AAFF"/>
    <circle r="2.5" transform="matrix(-1 0 0 1 18.5 5.5)" fill="#05AAFF"/>
    <circle r="2.5" transform="matrix(-1 0 0 1 18.5 18.5)" fill="#05AAFF"/>
    <circle r="2.5" transform="matrix(-1 0 0 1 21.5 12.5)" fill="#05AAFF"/>
    </svg>    
  )
}

export default CharadesIcon
